/* ============================================================
   S4H - "Kaufe den Look" als Pop-up auf der Startseite (31.08.)

   Laura: "Ich moechte, dass wenn man auf Kaufe den Look klickt
   auf der Startseite, dass ein Pop-up erscheint mit allen
   Produkten und dass man die direkt in die Wunschliste oder in
   den Warenkorb packen kann."

   EINE DATENQUELLE. Welche Teile zu einem Look gehoeren, in
   welcher Farbe und zu welchem Preis, rechnet Liquid in
   sections/s4h-looks.liquid aus. Diese Rechnung hier ein
   zweites Mal zu hinterlegen hiesse, sie bei jeder Aenderung an
   zwei Stellen zu pflegen. Stattdessen wird die Look-Seite
   einmal geholt und die fertige Ansicht daraus uebernommen.

   Ein echtes <dialog>: Escape, Verdunkelung, Fokusfalle und
   Fokusrueckgabe bringt der Browser mit.

   ------------------------------------------------------------
   GROESSEN IM FENSTER (31.08., zweiter Durchgang)

   Laura: "waere es nicht moeglich, die Groesse einzustellen im
   Pop-up selber." Und: "man kann die Sachen dann halt nur alle
   gleichzeitig in den Warenkorb packen, wenn man die Groessen
   angegeben hat."

   Genau so laeuft es: assets/s4h-groessen.js haengt an jede
   Zeile, bei der nach der Farbe mehr als eine Variante uebrig
   bleibt, ein Auswahlfeld. Der Knopf nimmt IMMER alle Teile -
   solange etwas fehlt, nennt er keine Summe.

   Der Hinweis darunter bleibt kurz und rot (Laura: "Bisschen zu
   viel Text als Hinweis, einfach ein roter, kurzer Hinweis").
   WELCHE Zeile gemeint ist, sagt beim Druecken der rote Rahmen
   am Feld, nicht der Satz.

   DIE KNOEPFE STEHEN IN DER FUSSZEILE. In der Liste stuenden
   sie unter dem letzten Teil und damit unter der Fensterkante.

   OHNE JAVASCRIPT bleibt die Kachel ein normaler Link auf
   /pages/hol-dir-den-look.
   ============================================================ */

(function () {
  'use strict';

  var WUNSCH_KEY = 's4h-wishlist';
  var LOOKSEITE = null;
  var dialog = null;
  var koerper = null;
  var aktion = null;
  var mehr = null;
  var geholt = null;

  function gr() { return window.S4hGroessen || null; }

  /* ---- Seite mit den Looks einmal holen -------------------- */

  function seiteHolen(url) {
    if (geholt) return geholt;
    geholt = fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('nicht erreichbar');
        return r.text();
      })
      .then(function (t) {
        return new DOMParser().parseFromString(t, 'text/html');
      });
    return geholt;
  }

  function melden(text) {
    var m = dialog.querySelector('.s4h-lk__meldung');
    if (m) m.textContent = text;
  }

  /* ---- Knopf beschriften ----------------------------------
     Der Knopf nimmt immer alle Teile. Die Summe erscheint erst,
     wenn ueber jede Zeile entschieden ist - eine Summe, die
     eine noch nicht gewaehlte Groesse mitrechnet, waere
     geraten.
     -------------------------------------------------------- */

  function knopfMalen() {
    var g = gr();
    var korb = aktion.querySelector('.s4h-lk__knopf--korb');
    if (!korb || !g) return;

    var s = g.stand(koerper);
    var wieviele = s.n === 1 ? 'Ein Teil' : 'Alle ' + s.n + ' Teile';
    korb.textContent = s.offen.length
      ? wieviele + ' in den Warenkorb'
      : wieviele + ' in den Warenkorb · ' + g.geld(s.summe);

    var hinweis = aktion.querySelector('.s4h-lk__offen');
    if (hinweis) hinweis.textContent = s.kurz;
  }

  /* ---- Warenkorb ------------------------------------------ */

  function inKorb(knopf, addUrl, cartUrl) {
    var g = gr();
    if (!g) return;

    var s = g.stand(koerper);
    if (s.offen.length) {
      /* Kein zweiter Satz: der rote Hinweis steht schon da, und
         markieren() faerbt die Felder, um die es geht. */
      melden('');
      g.markieren(koerper);
      return;
    }
    if (!s.ids.length) return;

    var posten = [];
    for (var i = 0; i < s.ids.length; i++) posten.push({ id: s.ids[i], quantity: 1 });

    knopf.disabled = true;
    melden('Wird hinzugefügt …');

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: posten })
    }).then(function (r) {
      if (r.ok) return r.json();
      return r.json().then(function (d) {
        throw new Error(d.description || d.message || 'Fehler');
      });
    }).then(function () {
      melden('Im Warenkorb. Einen Moment …');
      setTimeout(function () { window.location.href = cartUrl; }, 600);
    })['catch'](function (err) {
      knopf.disabled = false;
      melden('Hat nicht geklappt: '
        + (err && err.message ? err.message : 'bitte noch einmal versuchen') + '.');
    });
  }

  /* ---- Wunschliste ----------------------------------------
     Gleicher Schluessel und gleiches Format wie in
     assets/s4h-looks.js und assets/custom-script.js. Steht in
     der Zeile schon eine gewaehlte Variante, wird sie gemerkt -
     sonst die Farbe aus dem Link. Die Wunschliste nimmt IMMER
     alle Teile, auch die ohne Groesse: sie ist zum Merken da,
     nicht zum Kaufen.
     -------------------------------------------------------- */

  function lesen() {
    try {
      var roh = window.localStorage.getItem(WUNSCH_KEY);
      var p = roh ? JSON.parse(roh) : [];
      return Array.isArray(p) ? p : [];
    } catch (e) { return []; }
  }

  function zaehlerMalen(liste) {
    var nodes = document.querySelectorAll('[data-s4h-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = liste.length ? String(liste.length) : '';
      nodes[i].hidden = liste.length === 0;
    }
  }

  function ausLink(href) {
    var s = String(href || '');
    var teil = s.split('/products/')[1];
    if (!teil) return null;
    var handle = teil.split('?')[0].split('#')[0].split('/')[0];
    if (!handle) return null;
    var vid = 0;
    var q = s.split('variant=')[1];
    if (q) vid = parseInt(q.split('&')[0], 10) || 0;
    return { handle: handle, variant: vid };
  }

  function teileSammeln(knopf) {
    var out = [];
    var zeilen = koerper.querySelectorAll('.s4h-lk__teil');
    for (var i = 0; i < zeilen.length; i++) {
      var a = zeilen[i].querySelector('.s4h-lk__teilname');
      if (!a) continue;
      var t = ausLink(a.getAttribute('href'));
      if (!t) continue;
      var gewaehlt = parseInt(zeilen[i].getAttribute('data-vid'), 10);
      if (gewaehlt && zeilen[i].getAttribute('data-waehlbar') === '1') t.variant = gewaehlt;
      out.push(t);
    }
    if (out.length) return out;

    var roh = (knopf.getAttribute('data-handles') || '').split(',');
    for (var j = 0; j < roh.length; j++) {
      var h = String(roh[j] || '').trim();
      if (h) out.push({ handle: h, variant: 0 });
    }
    return out;
  }

  function aufWunschliste(knopf) {
    var teile = teileSammeln(knopf);
    var liste = lesen();
    var neu = 0;

    for (var i = 0; i < teile.length; i++) {
      var h = teile[i].handle;
      var vid = teile[i].variant;
      var vorhanden = null;
      for (var j = 0; j < liste.length; j++) {
        if (String(liste[j].handle || liste[j].id) === h) { vorhanden = liste[j]; break; }
      }
      if (!vorhanden) {
        var eintrag = { id: h, handle: h };
        if (vid) eintrag.variant = vid;
        liste.push(eintrag);
        neu++;
      } else if (vid && !vorhanden.variant) {
        vorhanden.variant = vid;
      }
    }

    try { window.localStorage.setItem(WUNSCH_KEY, JSON.stringify(liste)); }
    catch (e) {
      melden('Die Wunschliste lässt sich in diesem Browser nicht speichern.');
      return;
    }

    zaehlerMalen(liste);

    if (neu === 0) melden('Alle Teile stehen schon auf deiner Wunschliste.');
    else if (neu === 1) melden('Ein Teil auf die Wunschliste gelegt.');
    else melden(neu + ' Teile auf die Wunschliste gelegt.');
  }

  /* ---- Fenster -------------------------------------------- */

  function fensterBauen(reihe) {
    if (dialog) return dialog;

    var addUrl = reihe.getAttribute('data-korb-url') || '/cart/add';
    var cartUrl = reihe.getAttribute('data-warenkorb') || '/cart';

    dialog = document.createElement('dialog');
    dialog.className = 's4h-ld';
    dialog.setAttribute('aria-label', 'Kaufe den Look');
    dialog.innerHTML =
      '<div class="s4h-ld__kopf">'
      + '<h2 class="s4h-ld__titel">Kaufe den Look</h2>'
      + '<button type="button" class="s4h-ld__zu" aria-label="Fenster schließen">&times;</button>'
      + '</div>'
      + '<div class="s4h-ld__koerper"><p class="s4h-ld__laden">Einen Moment …</p></div>'
      + '<div class="s4h-ld__fuss">'
      + '<div class="s4h-ld__aktion"></div>'
      + '<a class="s4h-ld__mehr" href="' + LOOKSEITE + '">Look auf der ganzen Seite ansehen</a>'
      + '</div>';

    document.body.appendChild(dialog);
    koerper = dialog.querySelector('.s4h-ld__koerper');
    aktion = dialog.querySelector('.s4h-ld__aktion');
    mehr = dialog.querySelector('.s4h-ld__mehr');

    dialog.addEventListener('click', function (e) {
      if (e.target.closest('.s4h-ld__zu')) { dialog.close(); return; }
      /* Klick neben das Fenster: das Ziel ist dann der Dialog
         selbst, nicht ein Kind darin. */
      if (e.target === dialog) { dialog.close(); return; }

      var korb = e.target.closest('.s4h-lk__knopf--korb');
      if (korb) { inKorb(korb, addUrl, cartUrl); return; }

      var wunsch = e.target.closest('.s4h-lk__knopf--wunsch');
      if (wunsch) { aufWunschliste(wunsch); return; }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('s4h-ld-offen');
    });

    return dialog;
  }

  function fuellen(doc, kennung, nr) {
    var vorlage = kennung ? doc.getElementById('s4h-look-' + kennung) : null;
    if (!vorlage) {
      var alle = doc.querySelectorAll('template[id^="s4h-look-"]');
      vorlage = alle[nr] || alle[0];
    }
    if (!vorlage) {
      koerper.innerHTML = '<p class="s4h-ld__laden">Dieser Look lässt sich gerade nicht laden.</p>';
      return;
    }

    var teil = document.importNode(vorlage.content, true);

    /* Punkte im Foto und Bilderstreifen gehoeren zum Stoebern -
       im Fenster zaehlt die Liste. Weg damit, sonst laedt der
       Browser Bilder, die niemand sieht. */
    var weg = teil.querySelectorAll('.s4h-lk__punkte, .s4h-lk__minis, .s4h-lk__tipp');
    for (var i = 0; i < weg.length; i++) {
      if (weg[i].parentNode) weg[i].parentNode.removeChild(weg[i]);
    }

    /* Die Knoepfe nach unten holen, damit sie ohne Scrollen zu
       sehen sind. */
    aktion.innerHTML = '';
    var alles = teil.querySelector('.s4h-lk__alles');
    if (alles) aktion.appendChild(alles);

    koerper.innerHTML = '';
    koerper.appendChild(teil);
    koerper.scrollTop = 0;

    if (!alles) return;

    /* Liquid setzt den Korb-Knopf nur, wenn mindestens ein Teil
       ohne Rueckfrage mitgeht. Im Fenster gibt es die Auswahl -
       also gibt es den Knopf immer. */
    var korb = alles.querySelector('.s4h-lk__knopf--korb');
    if (!korb) {
      korb = document.createElement('button');
      korb.type = 'button';
      korb.className = 's4h-lk__knopf s4h-lk__knopf--korb';
      korb.textContent = 'In den Warenkorb';
      alles.insertBefore(korb, alles.firstChild);
    }
    var hinweis = alles.querySelector('.s4h-lk__offen');
    if (!hinweis) {
      hinweis = document.createElement('p');
      var meldung = alles.querySelector('.s4h-lk__meldung');
      alles.insertBefore(hinweis, meldung || null);
    }
    hinweis.className = 's4h-lk__offen s4h-gr__fehltext';
    hinweis.textContent = '';

    var g = gr();
    if (g) g.anbringen(koerper, knopfMalen);
  }

  function oeffnen(kachel, nr, reihe) {
    var d = fensterBauen(reihe);
    var ziel = kachel.getAttribute('href') || LOOKSEITE;
    if (mehr) mehr.setAttribute('href', ziel);

    koerper.innerHTML = '<p class="s4h-ld__laden">Einen Moment …</p>';
    aktion.innerHTML = '';
    document.body.classList.add('s4h-ld-offen');
    if (!d.open) d.showModal();

    seiteHolen(LOOKSEITE).then(function (doc) {
      fuellen(doc, kachel.getAttribute('data-look'), nr);
    })['catch'](function () {
      /* Wenn das Holen scheitert, bleibt der normale Weg: die
         Look-Seite. Kein Sackgassen-Fenster. */
      d.close();
      window.location.href = ziel;
    });
  }

  /* ---- Anbinden ------------------------------------------- */

  function anbinden() {
    var reihe = document.querySelector('.s4h-inf');
    if (!reihe || reihe.dataset.s4hLdBereit === '1') return;
    if (typeof HTMLDialogElement === 'undefined') return;
    reihe.dataset.s4hLdBereit = '1';
    LOOKSEITE = reihe.getAttribute('data-lookseite') || '/pages/hol-dir-den-look';

    reihe.addEventListener('click', function (e) {
      var kachel = e.target.closest('.s4h-inf__kachel');
      if (!kachel) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      var alle = reihe.querySelectorAll('.s4h-inf__kachel');
      var nr = Array.prototype.indexOf.call(alle, kachel);
      oeffnen(kachel, nr < 0 ? 0 : nr, reihe);
    });
  }

  /* Die Reihe haengt sich selbst per MutationObserver in die
     Startseite - sie ist beim Laden dieses Skripts also noch
     nicht da. Deshalb hier ebenfalls warten statt raten. */
  function warten() {
    anbinden();
    if (document.querySelector('.s4h-inf')) return;
    if (!('MutationObserver' in window)) return;
    var wache = new MutationObserver(function () {
      if (document.querySelector('.s4h-inf')) {
        anbinden();
        wache.disconnect();
      }
    });
    wache.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', warten);
  } else {
    warten();
  }
})();
